/**
 * グローバル AI チャットの FAB の固定位置。
 * 位置とクリアランスをここで一元管理し、FAB とそれを避ける側の値がずれないようにする。
 */
export const AI_CHAT_FAB_POSITION = 'fixed bottom-6 right-6';

/**
 * 下部固定要素（sticky なフォームアクション等）が FAB と重ならないための右余白。
 * FAB は右端から 24px（`right-6`）の位置に 44px（`w-11`）で描画されるため 68px を占有する。
 * それを上回る 96px（`pr-24`）を確保する。
 *
 * FAB 機能は環境によって無効（`useAiChatFabVisible`）のため、常時適用せず
 * 機能が有効な環境でのみ付与すること。
 */
export const AI_CHAT_FAB_CLEARANCE = 'pr-24';